/** Shared design tokens for the restyled portfolio. */

/** Monospace "engineer" utility face — used for eyebrows, labels, stats, badges. */
export const MONO = "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace";

/** Signature Tech Sand gold→cyan accent, matching the theme's primary/secondary. */
export const ACCENT_GRADIENT = 'linear-gradient(90deg, #d8aa78 0%, #8fd0d4 100%)';
